module.exports = __webpack_public_path__ + "img/bannerGuia2026.65057b64.png";